// Copyright (c) Docugami, Inc. All rights reserved.

import { ChunkInstance } from "networking/api";

export type DropTypes = DndType | DndType[];

export enum DndType {
    Chunk = 'Chunk',
    ReportItem = 'ReportItem',
    ReportItemGroup = 'ReportItemGroup'
}

export interface DndReportItemGroup extends DndItem {
    groupId: string;
}

export interface DndReportItem extends DndItem {
    entryId: string;
}

export interface DndChunk extends DndItem {
    instance: ChunkInstance;
    label: string;
}

export interface DndItem {
    type: DndType;
}

export const isDndChunk = (item: DndItem): item is DndChunk => item.type === DndType.Chunk;
export const isDndReportItem = (item: DndItem): item is DndReportItem => item.type === DndType.ReportItem;
export const isDndReportItemGroup = (item: DndItem): item is DndReportItemGroup => item.type === DndType.ReportItemGroup;
